import { Modal } from '@mantine/core';
import { randomId } from '@mantine/hooks';
import * as MantineModal from '@mantine/modals';

import type { AlertModalTemplateProps } from '@/new_src/view/components/Modal/AlertModalTemplate/AlertModalTemplate';
import { AlertModalTemplate } from '@/new_src/view/components/Modal/AlertModalTemplate/AlertModalTemplate';
import type { OpenConfirmModalProps } from '@/new_src/view/components/Modal/ConfirmModalTemplate';
import { ConfirmModalTemplate } from '@/new_src/view/components/Modal/ConfirmModalTemplate';
import { ModalResolver } from '@/new_src/view/components/Modal/resolver';

const openConfirmModal = (props: OpenConfirmModalProps) => {
  const modalID = props.id ?? randomId();
  return MantineModal.openModal({
    ...props,
    modalId: modalID,
    children: <ConfirmModalTemplate {...props} id={modalID} />,
  });
};

const openAlertModal = ({ modalId, ...modalProps }: AlertModalTemplateProps) => {
  const uniqueModalID = modalId ?? randomId();
  return MantineModal.openModal({
    modalId: uniqueModalID,
    withCloseButton: false,
    centered: true,
    styles: {
      content: {
        padding: 0,
      },
    },
    children: <AlertModalTemplate modalId={uniqueModalID} {...modalProps} />,
  });
};

const ModalManager = { ...MantineModal, openConfirmModal, openAlertModal };

export { ModalResolver, ConfirmModalTemplate, ModalManager, Modal };
